module.exports = __webpack_public_path__ + "static/floor-1-5fe803fd0a55fb38d39f5b6fee2271db.png";